<app-ui-document-panel-shell
  [breadcrumb]="breadcrumb"
  [title]="panelTitle"
  [documentId]="grn_no || ''"
  [statusLabel]="statusLabel"
  [statusVariant]="statusVariant"
  (closed)="onClose()">

  <app-ui-approval-stepper *ngIf="data?.id" [steps]="approvalSteps"></app-ui-approval-stepper>

  <app-ui-form-section title="General Information" icon="info">
  <div style="display: flex; justify-content: start; gap: 30px;">
      <!-- <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Vendor <span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="vendor" placeholder="Select Vendor" (ngModelChange)="getBranch($event)" [disabled]="isUpdateMode">
            <mat-option *ngFor="let item of vendordata" [value]="item.vendor_id">
              {{ item.vendor_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
      <div style="flex: 1;"  [matTooltip]="getVendorName(vendor)" [matTooltipDisabled]="!isUpdateMode" >
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Vendor <span style="color:red">*</span></mat-label>
          <mat-select #vendorSelect [(ngModel)]="vendor" [disabled]="isUpdateMode" panelClass="vendor-select-panel"
            (openedChange)="onVendorOpen($event)" (ngModelChange)="onVendorChange($event)">
            <mat-option disabled class="vendor-search-option">
              <input matInput placeholder="Search Vendor..." (keyup)="onVendorSearch($event.target.value)"
                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </mat-option>
            <mat-option *ngFor="let item of vendordata" [value]="item.vendor_id">
              {{ item.vendor_name }}
            </mat-option>
      
            <mat-option *ngIf="loadingVendor" disabled>
              Loading…
            </mat-option>
      
          </mat-select>
        </mat-form-field>
      </div>
      <!-- <div style="flex: 1">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Vendor Branch Name</mat-label>
          <input matInput type="text" [value]="selectedBranchName" disabled />
        </mat-form-field>
      </div> -->

      <div style="flex: 1"  [matTooltip]="getVendorBranchName(branch)" [matTooltipDisabled]="!isUpdateMode" >
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Vendor Branch Name<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="branch" placeholder="Select Vendor Branch Name"
            (ngModelChange)="fetchpo(vendor,branch)" [disabled]="isUpdateMode">
            <mat-option *ngFor="let branch of selectedBranch" [value]="branch.id">
              {{ branch.branch_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

     
      <div style="flex: 1;" [matTooltip]="getPurchaseOrder(po)" [matTooltipDisabled]="!isUpdateMode">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Purchase Order <span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="po" multiple placeholder="Select Purchase Order" (openedChange)="onPoOpen($event)"
            (ngModelChange)="onPoChange($event)" [disabled]="isView" panelClass="po-select-panel" [disabled]="isUpdateMode">
            <mat-option disabled class="po-search-option">
              <input matInput placeholder="Search PO..." (keyup)="onPoSearch($event.target.value)"
                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </mat-option>
            <mat-option *ngFor="let item of po_data" [value]="item.id">
              {{ item.po_no }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
        <!-- <div style="flex: 1;">
          <button mat-raised-button color="primary" (click)="onSearchClick()" 
              [disabled]="!po || po.length === 0" style="margin-left: 10px;margin-top: 15px;">
              Search
          </button>
      </div> -->
      <div style="flex: 1;" [matTooltip]="getBranchName(branch_id)" [matTooltipDisabled]="!isUpdateMode">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Branch<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="branch_id" placeholder="Select Branch" [disabled]="isUpdateMode"
         (ngModelChange)="onBranchChange()">
          <mat-option *ngFor="let item of filteredBranchData" [value]="item.id">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

      <div style="flex: 1;"  [matTooltip]="getProfitCostName(profitcost)" [matTooltipDisabled]="!isUpdateMode" >
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Profit/Cost Center <span style="color: red">*</span></mat-label>
          <!-- <mat-select [(ngModel)]="profitcost" placeholder="Select profit/cost center"
            (ngModelChange)="filterSectionsByProfitCost($event)" [disabled]="isUpdateMode"> -->
            <!-- <mat-select [(ngModel)]="profitcost" placeholder="Select profit/cost center"  [disabled]="isView"
            (ngModelChange)="onProfitCostChange($event)" multiple>
            <mat-option *ngFor="let item of profitCostData" [value]="item.id">
            <mat-select [(ngModel)]="profitcost" multiple placeholder="Select profit/cost center"  [disabled]="isView" [disabled]="isUpdateMode"
            (ngModelChange)="onProfitCostChange($event)">
            <mat-option *ngFor="let item of filteredProfitCostData" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select> -->
          <mat-select #profitCostSelect [(ngModel)]="profitcost" [disabled]="isView" [compareWith]="compareProfitCost"
            (ngModelChange)="onProfitCostChange($event)" (openedChange)="onProfitCostOpen($event)" multiple>
            <mat-option disabled>
              <input matInput placeholder="Search Profit/Cost Center..." (keyup)="onProfitCostSearch($event.target.value)"
                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            </mat-option>
            <mat-option *ngFor="let item of displayProfitCostData" [value]="item.id">
              {{ item.name }}
            </mat-option>
            <mat-option *ngIf="loadingProfitCost" disabled>
              Loading...
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex: 1;" [matTooltip]="getSectionName(section)" [matTooltipDisabled]="!isUpdateMode" >
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select Section <span style="color: red">*</span></mat-label>
          <!-- <mat-select [(ngModel)]="section" placeholder="Select Section"
            (ngModelChange)="fetchProductList(po,section)" [disabled]="isUpdateMode"> -->
            <mat-select [(ngModel)]="section" multiple placeholder="Select Section"  [disabled]="isView" [disabled]="isUpdateMode"
            (ngModelChange)="onSectionChange($event)">
            <mat-option *ngFor="let section of filteredSectionData" [value]="section.id">{{ section.section_name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex: 1;">
          <mat-form-field appearance="outline" style="width: auto;">
            <mat-label>External Document No <span style="color: red">*</span></mat-label>
            <!-- <input matInput type="text" [(ngModel)]="document_no" placeholder="External Document No"> -->
             <input matInput type="text" [(ngModel)]="document_no" placeholder="External Document No"  [disabled]="isView">
          </mat-form-field>
        </div>
    <!-- <div style="flex: 1;">
      <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>GSRN No</mat-label>
          <input matInput type="text" [(ngModel)]="grn_no" disabled>
      </mat-form-field>
  </div> -->
    <div style="flex: 1;">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Date<span style="color: red">*</span></mat-label>
        <input type="date" matInput [(ngModel)]="date" class="custom-input" [max]="maxDate"  [disabled]="isView">
      </mat-form-field>
    </div>
  
     <div style="flex: 1;">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Invoice Date<span style="color: red">*</span></mat-label>
        <input type="date" matInput [(ngModel)]="invoice_date" class="custom-input" [disabled]="isView">
      </mat-form-field>
    </div>

     <div style="flex: 1;">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Invoice Received Date<span style="color: red">*</span></mat-label>
        <input type="date" matInput [(ngModel)]="invoice_receive_date" class="custom-input" [disabled]="isView">
      </mat-form-field>
    </div>
 </div>
  </app-ui-form-section>

<app-ui-form-section title="Line Items" icon="list_alt">
<p class="ui-doc-panel-table-hint">Scroll inside the table area to view all columns and rows.</p>
<div class="ui-doc-panel-table-scroll" *ngIf="productList">
  <table class="product-table ui-doc-line-table">
    <thead>
      <tr>
        <th>Profit/Cost Center</th>
        <th>Section</th>
        <th>Po No</th>
        <th>Category Name</th>
        <th>Item/Service Name</th>
        <th>HSN/SAC No</th>
        <th>Specification</th>
        <th>Description</th>
        <th>UOM</th>
        <th>PO Quantity</th>
        <th>Unit Price</th>
        <th>Total Price</th>
        <th>Start Date</th>
        <th>Delivery Date</th>
        <!-- <th>Vendor Branch Name</th> -->
        <th>PO Pending Quantity</th>
        <th>GSRN Receive Qty</th>
        <th *ngIf="is_reverse">Reverse Qty</th>
        <th>GSRN Received Qty</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let product of productList">
        <ng-container *ngFor="let detail of product.po_details;let i = index">
          <ng-container *ngIf="detail?.remaining_qty !== 0">
          <tr>
            <!-- <td>{{ detail.item_service_type === 'SKU' ? detail?.stock_keeping?.sku_name : detail?.service?.service_name }}</td> -->
             <td>{{ detail?.profitcost?.name }}</td>
             <td>{{ detail?.section?.section_name }}</td>
             <td>{{ product.po_no }}</td>
             <td>{{
              detail.item_service_type === 'SKU'
              ? detail?.stock_keeping?.profit_cost_category?.category?.category_name
              : detail.item_service_type === 'Service'
              ? detail?.service?.profit_cost_category?.category?.category_name
              : detail.item_service_type === 'Fixed Asset'
              ? detail?.fa_template?.home_entity_category?.category_name
              : ''
              }}</td>
            <td>
              {{
              detail.item_service_type === 'SKU'
              ? detail?.stock_keeping?.item?.item_name
              : detail.item_service_type === 'Service'
              ? detail?.service?.service_name
              : detail.item_service_type === 'Fixed Asset'
              ? detail?.fa_template?.name
              : ''
              }}
            </td>
            <td>{{ detail?.hsn_no }}</td>
            <td>{{ detail?.specification }}</td>
            <td class="ui-doc-line-table__wrap">{{ detail?.description }}</td>
            <td>{{ detail?.unit?.unit_name }}</td>
            <td>{{ detail?.qty | number: '1.2-2'}}</td>
            <td>{{ detail?.unit_price | number: '1.2-2'}}</td>
            <td>{{ detail?.price | number: '1.2-2'}}</td>
            <td>{{ detail?.start_date }}</td>
            <td>{{ detail?.end_date }}</td>
            <!-- <td>{{ product?.vendor_branch?.branch_name }}</td> -->
            <!-- <td>{{ getRemainingQty(detail) | number: '1.2-2'}}</td> -->
             <td>{{ detail?.remaining_qty }}</td>
            <td><input type="number" [(ngModel)]="detail.receive_qty" placeholder="Receive Qty" style="width: auto;"min="0" [disabled]="isView" (keypress)="allowOnlyNumbers($event)"/>
            </td>
            <td>{{ ((detail?.qty || 0) - (detail?.remaining_qty) || 0) | number: '1.2-2' }}</td>
          </tr>
        </ng-container>
        </ng-container>
        <ng-container *ngFor="let detail of product.details;let i = index">
          <tr>
            <!-- <td>{{ detail.item_service_type === 'SKU' ? detail?.sku?.sku_name : detail?.service?.service_name }}</td> -->
             <td>{{ detail?.profit_cost?.name }}</td>
             <td>{{ detail?.section?.section_name }}</td>
             <td>{{ detail?.purchase_order?.po_no }}</td>
            <td>{{
              detail.item_service_type === 'SKU'
              ? detail?.sku?.profit_cost_category?.category?.category_name
              : detail.item_service_type === 'Service'
              ? detail?.service?.profit_cost_category?.category?.category_name
              : detail.item_service_type === 'Fixed Asset'
              ? detail?.fa_template?.home_entity_category?.category_name
              : ''
              }}</td>
            <td>
              {{
              detail.item_service_type === 'SKU'
              ? detail?.sku?.item?.item_name
              : detail.item_service_type === 'Service'
              ? detail?.service?.service_name
              : detail.item_service_type === 'Fixed Asset'
              ? detail?.fa_template?.name
              : ''
              }}</td>
              <td>{{ detail?.hsn_no }}</td>
              <td>{{ detail?.specification }}</td>
            <td class="ui-doc-line-table__wrap">{{ detail?.description }}</td>
            <td>{{ detail?.unit?.unit_name }}</td>
            <td>{{ detail?.qty | number: '1.3-3'}}</td>
            <td>{{ detail?.unit_price | number: '1.2-2'}}</td>
            <td>{{ detail?.price | number: '1.2-2'}}</td>
            <td>{{ detail?.start_date }}</td>
            <td>{{ detail?.end_date }}</td>
            <!-- <td>{{ product?.vendor_branch?.branch_name }}</td> -->
            <td>{{ getInitialTotal(detail) | number: '1.2-2'}}</td>
            <td><input type="number" [(ngModel)]="detail.receive_qty" placeholder="Receive Qty" style="width: auto; "min="0.001" step="0.001"  [disabled]="isView || is_reverse" (keypress)="allowOnlyNumbers($event)" />
              <td *ngIf="is_reverse"><mat-form-field appearance="outline">
            <input matInput type="number" [(ngModel)]="detail.reverse_qty"  min="0.001" step="0.001" (ngModelChange)="onReverseQtyChange(detail)" (keypress)="allowOnlyNumbers($event)" required>
          </mat-form-field></td>
            <td>{{ detail?.receive_qty | number: '1.3-3'}}</td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
</div>
</app-ui-form-section>

<div style="margin-bottom: 20px;" *ngIf="vendordetails">
  <app-ui-form-section title="Vendor Branch Details" icon="store">
  <div style="margin-top: 20px; border: 1px solid #000; padding: 10px;width: 50%">
    <table style="width: 100%; border-collapse: collapse; margin-top: 5px;">
      <tr>
        <td style="width: 50%; padding: 5px;"><strong>Branch Name:</strong>{{ vendordetails?.branch_name || 'NA' }}</td>
        <td style="width: 50%; padding: 5px;"><strong>GST No:</strong>{{ vendordetails?.gst_number || 'NA' }}</td>
      </tr>
      <tr>
        <td style="width: 50%; padding: 5px;"><strong>Email:</strong>{{ vendordetails?.email || 'NA' }}</td>
        <td style="width: 50%; padding: 5px;"><strong>Phone:</strong>{{ vendordetails?.phone || 'NA' }}</td>
      </tr>
      <tr>
        <td style="width: 50%; padding: 5px;"><strong>Address:</strong>{{ vendordetails?.address || 'NA' }}</td>
      </tr>
    </table>
  </div>
  </app-ui-form-section>
</div>

  <app-ui-form-section title="Attachments" icon="attach_file">
    <app-ui-document-file-upload
      [disabled]="isInputDisabled"
      [files]="uploadedFiles"
      [showViewLink]="!!data?.id"
      (filesSelected)="onFileSelected($event)"
      (removeFile)="removeFile($event)"
      (viewFiles)="openGrnFileShowModal()">
    </app-ui-document-file-upload>
  </app-ui-form-section>

<app-ui-form-section title="Remarks" icon="notes">
<div style="margin-top: 30px;">
  <mat-form-field appearance="fill" style="width: 500px;">
    <mat-label>Remark</mat-label>
     <textarea matInput [(ngModel)]="remark" placeholder="remark" rows="3" [disabled]="isInputDisabled"></textarea>
  </mat-form-field>
</div>
</app-ui-form-section>

<div *ngIf="!productList">
  <p>No data available.</p>
</div>

<app-ui-document-panel-footer
  [primaryActions]="footerPrimaryActions"
  [secondaryActions]="footerSecondaryActions"
  [destructiveAction]="footerDestructiveAction"
  [overflowActions]="footerOverflowActions"
  (actionClick)="onFooterAction($event)">
</app-ui-document-panel-footer>

</app-ui-document-panel-shell>